




















// vendor
import { defineComponent } from "@vue/composition-api";
// local
import TitleHeader from "./scene-form/title-header.vue";

export default defineComponent({
	emits:[ "previous", "next" ],
	props:{
		showBack:{
			type:Boolean,
			default:true
		},
		isLast:{
			type:Boolean,
			default:false
		}
	},
	setup(props, context){
		const onPrevious = () => context.emit("previous");
		const onNext = () => context.emit("next");
		return {
			onPrevious,
			onNext
		};
	}
});

